// Fetches and caches workforce data from the dashboard API.
//
// The Year 2 taxonomy (dropdown structure, field lookups, value formatting,
// color scales, legend titles, suppression handling) lives in metricRegistry.ts.
// This service is data access only.
class WorkforceDataService {
    constructor() {
        // Cache for API responses
        this.cachedCountyData = null;
        this.cachedStateData = null;
        this.apiBaseUrl = '/dashboard/api';
    }
    async getCountyData() {
        if (this.cachedCountyData) {
            return this.cachedCountyData;
        }
        const response = await fetch(`${this.apiBaseUrl}/countydata/`);
        const allCountyData = await response.json();
        this.cachedCountyData = allCountyData;
        return allCountyData;
    }
    async getStateData() {
        if (this.cachedStateData) {
            return this.cachedStateData;
        }
        const response = await fetch(`${this.apiBaseUrl}/statedata/`);
        const stateData = await response.json();
        this.cachedStateData = stateData;
        return stateData;
    }
    // Get data for a specific county
    async getCountyByName(stateName, countyName) {
        var _a, _b;
        const data = await this.getCountyData();
        return ((_b = (_a = data.data.counties) === null || _a === void 0 ? void 0 : _a[stateName]) === null || _b === void 0 ? void 0 : _b[countyName]) || null;
    }
    // Get data for a specific state
    async getStateByName(stateName) {
        var _a;
        const data = await this.getStateData();
        return ((_a = data.data.states) === null || _a === void 0 ? void 0 : _a[stateName]) || null;
    }
    // Get all counties for a state
    async getCountiesByState(stateName) {
        var _a;
        const data = await this.getCountyData();
        return ((_a = data.data.counties) === null || _a === void 0 ? void 0 : _a[stateName]) || {};
    }
    // Get all states
    async getAllStates() {
        const data = await this.getStateData();
        return data.data.states || {};
    }
    // Set API base URL
    setApiBaseUrl(url) {
        this.apiBaseUrl = url;
    }
    // Clear cached data to force refresh on next request
    clearCache() {
        this.cachedCountyData = null;
        this.cachedStateData = null;
    }
    clearCountyCache() {
        this.cachedCountyData = null;
    }
    clearStateCache() {
        this.cachedStateData = null;
    }
    // Force refresh data (clear cache and fetch fresh)
    async refreshCountyData() {
        this.clearCountyCache();
        return await this.getCountyData();
    }
    async refreshStateData() {
        this.clearStateCache();
        return await this.getStateData();
    }
}
// Export singleton instance
export const workforceDataService = new WorkforceDataService();
// Export default
export default workforceDataService;
